import { copy } from '../copy.js';
import { uiError } from './store.js';
import type { AppStore } from './store.js';

/**
 * Your colour, chosen once at the first sign-in (owner decision of 3 October 2026). Saved, then the
 * session is read again, which opens the app. Rejects with the data source's error.
 */
export async function chooseColour(s: AppStore, colour: string): Promise<void> {
  const save = s.data.setColour;
  if (!save) return;
  await save.call(s.data, colour);
  await s.start();
}

/** Sign out, from your own profile (owner decision of 2 October 2026). The app then shows the sign-in screen. */
export async function signOut(s: AppStore): Promise<void> {
  const st = s.getState();
  if (st.lv || st.pe || st.view === 'compose') return;
  try {
    await s.data.signOut();
    s.signedOut();
  } catch (reason) {
    s.report(uiError(reason));
    s.flash(copy.toast.signOutFailed);
  }
}
